<template>
  <div class="px-4 pb-4">
    <data-table :columns="columns" :rows="rows.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
      <template v-slot:actions="slotProps">
        <div class="button-items">
          <b-button v-if="checkForPermission(view_single_branch_permission)" variant="info" size="sm" class="py-1 text-white" @click="viewBranch(slotProps.row.publicId)">
            View Branch
          </b-button>
          <b-button v-if=checkForPermission(edit_branch_permission) v-b-modal.edit-branch variant="success" size="sm" class="py-1 text-white" @click="selectBranch(slotProps.row)">
            Edit Branch
          </b-button>
        </div>
      </template>
    </data-table>
    <b-modal
        id="edit-branch"
        centered
        size="lg"
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Branch</h3>
        <branch-form button_text="Edit Branch" :selected_branch="selected_branch" @branchAction="editBranch"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-branch')">Close</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {routeItems} from "@/router/endpoints";
import BranchForm from "@/components/customers/branch-form";
import DataTable from "@/components/data-table";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";

export default {
name: "all-branches",
  components: {DataTable, BranchForm},
  data(){
    return{
      selected_branch: {},
      edit_branch_permission: permissions.edit_branch_permission,
      view_single_branch_permission: permissions.view_single_branch_permission,
      columns: [
        {
          field: 'customerCode',
          label: 'Code'
        },
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'email',
          label: 'Email'
        },
        {
          field: 'phoneNumber',
          label: 'Phone Number'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ]
    }
  },
  props: {
    rows: {type: Object},
    currentPage: {type: Number, default: 1}
  },
  methods: {
    ... mapActions({
      updateBranch: 'customers/updateCustomerBranch'
    }),
    viewBranch(public_id){
      this.$router.push(routeItems.single_branch_route+'/'+public_id)
    },
    async editBranch(data){
      data.id = this.selected_branch.publicId
      await this.updateBranch(data).then(resp => {
        if(resp.publicId){
          this.$emit('updateBranch')
          successToast(`${resp.name} updated successfully`)
        }

      })
    },
    selectBranch(row){
      this.selected_branch = row
    },
    searchFn(data){
      this.$emit('onSearch', data)
    }
  }
}
</script>

<style scoped>

</style>
